/*
 * Abendkleid-Layout-Fix
 * Ursache: Der "sale_coupon"-Block im Produkt-Template schliesst zwei
 * Container-DIVs zu frueh. Dadurch fallen Kaufen-Button, Zahlungsarten und
 * Service-Bloecke aus der rechten Info-Spalte heraus.
 * Dieser Fix holt die herausgefallenen Bloecke zurueck in die Info-Spalte
 * und blendet die fehlerhafte Gutschein-Box aus. Auf korrekten Seiten
 * passiert nichts.
 */
(function () {
  function hideCoupons(root) {
    (root || document).querySelectorAll('.sale-coupon').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function run() {
    var info = document.querySelector('.product__info-container');
    if (!info) return; // keine Produktseite

    hideCoupons(document);

    // Button bereits in der Info-Spalte -> Seite ist korrekt, nichts tun.
    if (info.querySelector('product-form, .product-form')) return;

    var wrap = info.closest('.product__info-wrapper') || info.parentElement;
    if (!wrap || !wrap.parentElement) return;

    // Alle direkt folgenden Geschwister-Elemente (die herausgefallenen
    // Produktbloecke) zurueck in die Info-Spalte verschieben. Beim ersten
    // echten Abschnitt (Section) wird gestoppt.
    var sib = wrap.nextElementSibling;
    while (sib) {
      if (sib.classList.contains('shopify-section') || sib.querySelector('.shopify-section')) break;
      var next = sib.nextElementSibling;
      info.appendChild(sib);
      sib = next;
    }
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
